module.exports = __webpack_public_path__ + "static/media/flying_seagull_552368.a0359872.jpg";